//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'FallbackLinks',

  data() {
    return {
      isInAppBrowser: false,
      isIOS: false,
      isAndroid: false,
    }
  },

  computed: {
    // URL de la página intermedia que se abre en Chrome/Safari (fuera del WebView de Instagram)
    redirectPageUrl() {
      const { deepLink } = this.$route.query
      const deepLinkParam = deepLink || this.$route.fullPath

      return `https://app.fanaty.com/deep-link-redirect?deepLink=${encodeURIComponent(deepLinkParam)}`
    },

    // URL intent:// para abrir la app directamente en Android
    intentUrl() {
      const { deepLink } = this.$route.query
      const deepLinkParam = deepLink || this.$route.fullPath
      const [cleanPath] = deepLinkParam.split('?')
      const path = `app.fanaty.com${cleanPath}`
      const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.fanaty'
      const fallback = encodeURIComponent(playStoreUrl)

      return `intent://${path}#Intent;scheme=https;package=com.fanaty;S.browser_fallback_url=${fallback};end`
    },
  },

  beforeCreate() {
    const ua = navigator.userAgent || navigator.vendor || window.opera

    const isInstagram = /Instagram/i.test(ua)
    const isTikTok = /TikTok|musical_ly|BytedanceWebview/i.test(ua)
    const isFacebook = /FBAN|FBAV|FB_IAB|FacebookExternalHit/i.test(ua)

    const isInApp = isInstagram || isTikTok || isFacebook

    if (!isInApp) {
      // Comportamiento original: redirigir al store
      const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream
      const isAndroid = /android/i.test(ua)

      const appStoreUrl = 'itms-apps://apps.apple.com/us/app/fanaty/id1461051554'
      const playStoreUrl = 'market://details?id=com.fanaty'
      const webUrl = 'https://www.fanaty.com/videos'

      if (isIOS) {
        window.location.replace(appStoreUrl)
      } else if (isAndroid) {
        window.location.replace(playStoreUrl)
      } else {
        window.location.replace(webUrl)
      }
    }
  },

  created() {
    const ua = navigator.userAgent || navigator.vendor || window.opera

    const isInstagram = /Instagram/i.test(ua)
    const isTikTok = /TikTok|musical_ly|BytedanceWebview/i.test(ua)
    const isFacebook = /FBAN|FBAV|FB_IAB|FacebookExternalHit/i.test(ua)

    this.isInAppBrowser = isInstagram || isTikTok || isFacebook
    this.isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream
    this.isAndroid = /android/i.test(ua)

    // Detectar idioma del teléfono para in-app browsers si no hay preferencia previa
    if (!localStorage.getItem('lang')) {
      const browserLang = (navigator.language || '').split('-')[0]
      this.$i18n.locale = browserLang === 'es' ? 'es' : 'en'
    }

    // Android in-app browser: intentar abrir la app automáticamente al cargar
    if (this.isInAppBrowser && this.isAndroid) {
      window.location.href = this.intentUrl
    }
  },

  methods: {
    openApp() {
      if (this.isIOS) {
        // iOS: window.open está bloqueado en WebViews de Instagram/TikTok/Facebook.
        // Universal Links tampoco funcionan desde in-app browsers (WKWebView de Apple).
        // Intentar abrir la app directamente via Custom URL Scheme (fanaty://)
        const { deepLink } = this.$route.query
        const deepLinkParam = deepLink || this.$route.fullPath
        const normalizedDeepLink = decodeURIComponent(String(deepLinkParam || ''))
          .replace(/^https?:\/\/[^/]+/i, '') // soporta deep links absolutos
          .replace(/^\/+/, '') // evita fanaty:///...

        const customSchemeUrl = `fanaty://${normalizedDeepLink}`
        window.location.href = customSchemeUrl

        // Si la app no está instalada, después de 2s ir al App Store
        const fallbackTimer = setTimeout(() => {
          window.location.href = 'itms-apps://apps.apple.com/us/app/fanaty/id1461051554'
        }, 2000)

        let onVisibilityChange
        let onPageHide

        const clearFallback = () => {
          clearTimeout(fallbackTimer)
          if (onVisibilityChange) document.removeEventListener('visibilitychange', onVisibilityChange)
          if (onPageHide) window.removeEventListener('pagehide', onPageHide)
        }

        // Si la app se abrió, cancelar el fallback para q no vaya al store cuando vuelva
        onVisibilityChange = () => {
          if (document.hidden) {
            clearFallback()
          }
        }
        onPageHide = () => {
          clearFallback()
        }
        document.addEventListener('visibilitychange', onVisibilityChange)
        window.addEventListener('pagehide', onPageHide)
      } else if (this.isAndroid) {
        // Android: ir al Play Store directamente
        window.location.href = 'https://play.google.com/store/apps/details?id=com.fanaty'
      }
    },
  },
}
